import React from "react";
import { Modal, Text } from "@networkraildigitalfactory/components";
import useDisableScroll from "../../../hooks/useDisableScroll";

const Logout = (props) => {
  useDisableScroll(props.show);
  return (
    <Modal
      type="confirm"
      cancelText="No"
      cancelButtonColor="red"
      confirmText="Yes"
      show={props.show}
      onClose={props.close}
      onConfirm={props.confirm}
      describedBy="logout-title"
      labelledBy="logout-body"
      style={{ maxWidth: "90%", width: "690px", position: "fixed", zIndex: 1000 }}
      focusOnClose="toolbarLogout"
    >
      <div className="logout-body">
        <Text wrapper="h1" type="header" style={{ lineHeight: "140%", letterSpacing: "0.0015em" }}>
          Logout
        </Text>
        <Text wrapper="span" type="body">
          Are you sure you want to logout? Any unsaved or unsubmitted changes will be lost.
        </Text>
      </div>
    </Modal>
  );
};

export default Logout;
